export default __webpack_public_path__ + "static/content-46c63514d820844eb2ad5b0c17bbbe0e.jpg";